import template from './price-rent-daily.jade';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

export default angular
  .module('cian.addForm.priceRentDaily', [])
  .directive('cianAfPriceAndDealTermsPriceRentDaily', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller($scope, adTooltipsService, analyticsService, deviceService, popupService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Цена за сутки';
      this.tooltipText = '';

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'bargainTerms.price',
        trackingLabel: 'price-rent-daily-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
    controllerAs: 'priceRentDaily',
    template,
  })).name;
